var _style, _circle, _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#496E2D;}\n\t.st1{fill:#F0F0F0;}\n\t.st2{fill:#FFDA44;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.5,245.3c-6.3,0-12.3,1.3-17.8,3.2c3-6.8,5.1-14.3,5.1-22.3c0-31.8-31.8-55.7-31.8-55.7 s-31.8,23.9-31.8,55.7c0,8,2,15.6,5.1,22.3c-5.5-2-11.5-3.2-17.8-3.2c-31.8,0-55.7,31.8-55.7,31.8s23.9,31.8,55.7,31.8 c18.6,0,34.5-10.9,44.5-20c10,9,25.9,20,44.5,20c31.8,0,55.7-31.8,55.7-31.8S332.3,245.3,300.5,245.3L300.5,245.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,100.2l6.6,20.2h21.3l-17.2,12.5l6.6,20.2L256,140.6l-17.2,12.5l6.6-20.2l-17.2-12.5h21.3L256,100.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M175.2,135.5l12.6,11.4l14.7-8.5l-6.9,15.5l12.6,11.4l-16.9-1.8l-6.9,15.5l-3.5-16.6l-16.9-1.8l14.7-8.5 L175.2,135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M116,194.7l16.6,3.5l8.5-14.7l1.8,16.9l16.6,3.5l-15.5,6.9l1.8,16.9l-11.4-12.6l-15.5,6.9l8.5-14.7L116,194.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M336.8,135.5l-12.6,11.4l-14.7-8.5l6.9,15.5l-12.6,11.4l16.9-1.8l6.9,15.5l3.5-16.6l16.9-1.8l-14.7-8.5 L336.8,135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M396,194.7l-16.6,3.5l-8.5-14.7l-1.8,16.9l-16.6,3.5l15.5,6.9l-1.8,16.9l11.4-12.6l15.5,6.9l-8.5-14.7 L396,194.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,398c25.3,0,48.5-8.4,67.2-22.6H188.8C207.5,389.5,230.7,398,256,398L256,398z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154,331.2c3.5,8.1,8,15.7,13.3,22.6h177.5c5.3-6.9,9.7-14.5,13.3-22.6H154z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMo);
export default __webpack_public_path__ + "static/media/mo.9bc89badc311fb9e52914502e1478e5a.svg";
export { ForwardRef as ReactComponent };